import ReactOnRails from 'react-on-rails';
import { exists } from '@engine/lib/utility/exists';
/**
 * Private Helpers
 */

function getPanelsForUpdate(changed_features) {
  var panelsMap = [{
    selector: 'logo-panel',
    features: ['show_merchant_logo']
  }, {
    selector: ['tac-panel', 'tac-policy-template-panel'],
    features: ['show_merchant_terms_and_conditions', 'show_reseller_terms_and_conditions']
  }, {
    selector: ['privacy-panel', 'tac-policy-template-panel'],
    features: ['show_merchant_privacy_policy']
  }, {
    selector: 'css-panel',
    features: ['show_custom_wpf_css']
  }, {
    selector: 'footer-text-panel',
    features: ['show_merchant_footer_text']
  }, {
    selector: 'tac-policy-template-panel',
    features: ['show_terms_and_policy_template']
  }];
  return $.map(changed_features, function (feature) {
    var selector = null;
    $.each(panelsMap, function (index, panel) {
      if (panel.features.includes(feature)) {
        selector = panel.selector;
        panel.features = [];
        return;
      }
    });
    return selector;
  });
}

function panelsIterator(panelsForUpdate, callback) {
  $.each(panelsForUpdate, function (_index, panel) {
    callback(panel);
  });
}

function showPanelLoaderFor(panelsForUpdate, showFlag) {
  var method = showFlag === true ? 'addClass' : 'removeClass';
  panelsIterator(panelsForUpdate, function (panel) {
    $('#' + panel).parents('.panel').find('.spinner')[method]('in');
  });
}

function updatePanels(panelsForUpdate, html) {
  panelsIterator(panelsForUpdate, function (panel) {
    $('#' + panel).html($(html).find('#' + panel).html());

    if (panel === 'css-panel') {
      var component = $('script[data-component-name="MerchantWpfThemes"]');

      if (!exists(component)) {
        return;
      }

      var componentName = 'MerchantWpfThemes';
      var componentId = component.attr('data-dom-id');
      var componentProps = JSON.parse(component.text());
      ReactOnRails.render(componentName, componentProps, componentId);
    }
  });
}
/**
 * Public
 */

/**
 * Get the new HTML for changed features related panels
 * Custom CSS, Logo upload & etc. panels
 *
 * @param {Array} changed_features Changed features names.
 * @return {void}
 */


function updateDependentFeaturesPanels(changed_features) {
  var panelsForUpdate = getPanelsForUpdate(changed_features);

  if (!exists(panelsForUpdate)) {
    return;
  }

  $.ajax({
    type: 'GET',
    url: window.location.href,
    dataType: 'html',
    beforeSend: function beforeSend() {
      showPanelLoaderFor(panelsForUpdate, true);
    }
  }).done(function (html) {
    updatePanels(panelsForUpdate, html);
  }).always(function () {
    showPanelLoaderFor(panelsForUpdate, false);
  });
}

var WpfPanels = {
  updateDependentFeaturesPanels: updateDependentFeaturesPanels
};
export default WpfPanels;